import React, { useState } from "react";
import MedicamentList from "../medicament/MedicamentList";
import PatientHeader from "./PatientHeader";
import PatientHistoryModal from "./PatientHistoryModal";
import PatientIdentityFields from "./PatientIdentityFields";
import ValidatePatientAction from "./ValidatePatientAction";
import ValidationCards from "./ValidationCards";
import { labelStyle, sectionTitleStyle, textareaStyle, whiteCardStyle } from "./patientFormStyles";

const COMMENT_FIELDS = [
    { field: "commentaryProductionRobot", label: "Commentaire pour la prod robot (facultatif)" },
    { field: "commentaryProductionEtiquetage", label: "Commentaire pour la prod étiquetage" },
];

function ProductionComments({ patient, onFieldChange }) {
    return (
        <div className="commande-editor-comments" style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
            marginTop: "16px",
            ...whiteCardStyle,
        }}>
            {COMMENT_FIELDS.map(({ field, label }) => (
                <div key={field}>
                    <label style={labelStyle}>{label}</label>
                    <textarea
                        style={textareaStyle}
                        value={patient[field] || ""}
                        onChange={e => onFieldChange(field, e.target.value)}
                        placeholder="Commentaire"
                    />
                </div>
            ))}
        </div>
    );
}

// Fiche du patient sélectionné : identité, validations, traitements et
// commentaires de production. `editing` vient de usePatientFormEditing.
export default function PatientDetail({
    patient,
    editing,
    validations,
    patientValidation,
    ehpadId,
    listProps,
    onValidatePatient,
    patientValidationField,
    patientValidationLabel,
    canValidatePatient,
}) {
    const [showHistory, setShowHistory] = useState(false);
    const produits = patient.produits || [];
    const validatePatientAction = onValidatePatient
        && canValidatePatient(patient)
        && !patient[patientValidationField] ? (
        <ValidatePatientAction
            validating={patientValidation.validating}
            error={patientValidation.error}
            onValidate={patientValidation.validateSelectedPatient}
            label={patientValidationLabel}
        />
    ) : null;

    return (
        <>
        <div className="commande-editor-patient-detail" style={{ padding: "20px 24px 32px" }}>
            <PatientHeader
                patient={patient}
                index={editing.selectedIdx}
                onRemove={editing.removeSelectedPatient}
                onHistory={() => setShowHistory(true)}
            />

            <PatientIdentityFields
                patient={patient}
                ehpadId={ehpadId}
                nomInputRef={editing.nomInputRef}
                onFieldChange={editing.updatePatientField}
                onSelectSuggestion={editing.selectSuggestion}
            />

            <ValidationCards
                produits={produits}
                validationOverrides={validations.validationOverrides}
                onToggle={validations.toggleValidation}
            />

            <div className="commande-editor-treatments">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                    <span style={sectionTitleStyle}>
                        Traitements · {produits.length}
                    </span>
                </div>
                <MedicamentList
                    {...listProps}
                    produits={produits}
                    onChange={editing.setSelectedProduits}
                    focusLastNom={editing.focusDrugNomOnAdd}
                    onLastNomFocused={editing.clearDrugNomFocus}
                    onAddProduit={editing.addDrugToSelected}
                    validatePatientAction={validatePatientAction}
                />

                <ProductionComments patient={patient} onFieldChange={editing.updatePatientField} />
            </div>
        </div>
        {showHistory && patient.id && <PatientHistoryModal patient={patient} onClose={() => setShowHistory(false)} />}
        </>
    );
}
